import { render, staticRenderFns } from "./WapMaterielIndex.vue?vue&type=template&id=0761cc3a&scoped=true&"
import script from "./WapMaterielIndex.vue?vue&type=script&lang=js&"
export * from "./WapMaterielIndex.vue?vue&type=script&lang=js&"
import style0 from "./WapMaterielIndex.vue?vue&type=style&index=0&id=0761cc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761cc3a",
  null
  
)

export default component.exports